import {StyledRowSelectionText} from '@components/commons/selected-rows-text/style.ts'
import {FC} from 'react'
import {useTranslation} from '@/translations/i18n.tsx'

export const SelectedRowsText: FC<{count: number}> = ({count}) => {
    const {t} = useTranslation()

    return <StyledRowSelectionText>{t('commons:x_selected', {count})} </StyledRowSelectionText>
}
